import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "status" }
const _hoisted_2 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_3 = ["data-dp-tooltip"]
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "abstract" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "created text-nowrap" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "buttons" }
const _hoisted_12 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_13 = ["data-dp-tooltip"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "content_copy", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1)
const _hoisted_17 = ["data-dp-tooltip"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductListTile = _resolveComponent("ProductListTile")!
  const _component_ButtonContentPagePreview = _resolveComponent("ButtonContentPagePreview")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("i", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.updateStatus(_ctx.snippet.page_id, _ctx.snippet.status.code === _ctx.StatusEnum.PUBLISHED ? _ctx.StatusEnum.NOT_PUBLISHED : _ctx.StatusEnum.PUBLISHED)), ["prevent"])),
          class: _normalizeClass(["mas mas-fill-1", [_ctx.snippet.status.code === _ctx.StatusEnum.PUBLISHED ? 'text-success' : 'text-danger', _ctx.canUpdateSnippet ? 'cu-p' : '']]),
          "data-dp-tooltip": _ctx.snippet.status.code === _ctx.StatusEnum.PUBLISHED ? _ctx.$t('published') : _ctx.$t('notPublished')
        }, " circle ", 10, _hoisted_3)
      ])
    ]),
    _createElementVNode("td", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.snippet.name), 1)
    ]),
    _createElementVNode("td", _hoisted_6, [
      (_ctx.product)
        ? (_openBlock(), _createBlock(_component_ProductListTile, {
            key: 0,
            product: _ctx.product
          }, null, 8, ["product"]))
        : _createCommentVNode("", true),
      (_ctx.snippet.context?.trademark_code)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('trademark')) + ": " + _toDisplayString(_ctx.trademark), 1))
        : _createCommentVNode("", true),
      (_ctx.snippet.context?.category_code)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t('category')) + ": " + _toDisplayString(_ctx.category) + " (" + _toDisplayString(_ctx.snippet.context.is_include_subcategory ? _ctx.$t('includingSubcategories') : _ctx.$t('withoutSubcategories')) + ") ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_9, [
      (_ctx.snippet.created && _ctx.snippet.created !== '')
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.formatDate(new Date(_ctx.snippet.created))), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('copy',_ctx.snippet.id))),
          class: "btn btn-icon btn-warning ms-2",
          "data-dp-tooltip": _ctx.$t('copy'),
          "data-dp-position": "left"
        }, _hoisted_15, 8, _hoisted_13),
        _createVNode(_component_ButtonContentPagePreview, {
          "page-id": _ctx.snippet.page_id,
          "data-dp-tooltip": _ctx.$t('preview'),
          "data-dp-position": "left",
          class: "ms-2"
        }, null, 8, ["page-id", "data-dp-tooltip"]),
        _createVNode(_component_router_link, {
          to: {name: 'edit-snippet-wysiwyg', params: {id: _ctx.snippet.page_id, snippetId: _ctx.snippet.id}},
          class: "btn btn-icon btn-primary ms-2",
          "data-dp-tooltip": _ctx.$t('edit'),
          "data-dp-position": "left"
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["to", "data-dp-tooltip"]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('delete',_ctx.snippet.id))),
          class: "btn btn-icon btn-danger ms-2",
          "data-dp-tooltip": _ctx.$t('delete'),
          "data-dp-position": "left"
        }, _hoisted_19, 8, _hoisted_17)
      ])
    ])
  ]))
}